import React, { useState } from "react";

export default function Contact() {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 
        setLoading(true);
        setError("");

        try {
            const response = await fetch(
                "https://sattva-backend.demetrix.in/contact/contact_message",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            
            console.log("API Response:", data);

            if (response.status === 200) {
                setSuccess(true); 
            } else {
                throw new Error(data.message || "Something went wrong");
            }

        } catch (err) {
            console.error("Error:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="relative py-16 bg-gray-50 dark:bg-slate-800" id="contact">
            <div className="container">
                <div className="grid grid-cols-1 text-center">
                    <h6 className="text-blue-600 text-base font-medium uppercase mb-2">
                        Contact us
                    </h6>
                    <h3 className="mb-4 md:text-2xl text-xl font-medium dark:text-white">
                        Get In Touch !
                    </h3>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 mt-8 items-center gap-6">
                    <div className="lg:col-span-8">
                        <div className="p-6 rounded-md shadow-lg p-8 bg-white dark:bg-slate-900 ">
                            <form onSubmit={handleSubmit}>

                                <div className="grid lg:grid-cols-12 lg:gap-6">
                                    <div className="lg:col-span-6 mb-5">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-input"
                                            placeholder="Name :"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="lg:col-span-6 mb-5">
                                        <input
                                            name="email"
                                            type="email"
                                            className="form-input"
                                            placeholder="Email :"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="mb-5">
                                    <input
                                        name="subject"
                                        className="form-input"
                                        placeholder="Subject :"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-5">
                                    <textarea
                                        name="message"
                                        className="form-input textarea h-28"
                                        placeholder="Message :"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>

                                {/* Button or Success Message */}
                                {!success ? (
                                    <button
                                        type="submit"
                                        className="btn bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 text-white rounded-md h-11 justify-center flex items-center"
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Send Message"}
                                    </button>
                                ) : (
                                    <div className="text-green-600 font-semibold text-lg">
                                         Request Sent Successfully
                                    </div>
                                )}

                              
                                {error && (
                                    <p className="text-red-600 mt-3">{error}</p>
                                )}

                            </form>
                        </div>
                    </div>
                    <div className="lg:col-span-4">
                            <div className=" p-2 space-y-4">
                                <div className="flex items-start gap-4">
                                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 text-blue-600">
                                        <i className="uil uil-phone text-2xl"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-lg font-medium dark:text-white">
                                            Call Us
                                        </h5>
                                        <a
                                            href="tel:+917034587125"
                                            className="text-slate-500 hover:text-blue-600"
                                        >
                                            +91 70345 87125
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4">
                                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-600">
                                        <i className="uil uil-whatsapp text-2xl"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-lg font-medium dark:text-white">
                                            WhatsApp Us
                                        </h5>
                                        <a
                                            href="https://wa.me/917034587125"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-slate-500 hover:text-green-600"
                                        >
                                            +91 70345 87125
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4">
                                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600">
                                        <i className="uil uil-envelope text-2xl"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-lg font-medium dark:text-white">
                                            Email
                                        </h5>
                                        <a
                                            href="mailto:connect@sattvaesg.com"
                                            className="text-slate-500 hover:text-purple-600"
                                        >
                                            connect@sattvaesg.com
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-100 text-orange-600">
                                        <i className="uil uil-map-marker text-2xl"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-lg font-medium dark:text-white">Address</h5>
                                        <p className="text-slate-500 hover:text-orange-500">
                                            TC 98/3629, Attipara, Kenz Avenue, <br/>
                                            Dotspace, Kazhakkoottam,<br />
                                            Thiruvananthapuram,<br />
                                            Kerala, India – 695582.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>
    );
}
